import $ from 'jquery';
import Cookies from 'js-cookie';
import { isEditorPage } from './page';
import { getSite, getSystem } from './site';
export function getCurrency() {
	var sys = getSystem()
	if (sys == 'ept') {
		if ($("#eptCur").val()) {
			return $("#eptCur").val()
		}
		if (!isEditorPage()) {
			try {
				var curStr = Cookies.get("eptCur")
				return JSON.parse(curStr).currency
			} catch (err) {
				//
			}
		}
		var site = getSite()
		var map = {
			'US': 'USD',
			'EU': 'EUR',
			'RU': 'RUB',
			'GB': 'GBP',
			'CA': 'CAD',
			'CH': 'CHF',
			'AU': 'AUD',
			'PL': 'PLN',
			'ES': 'EUR',
		}
		if (map[site]) {
			return map[site]
		}
		return 'USD'
	}
	if (sys == 'th') {
		// var language = getLanguage()
		// if (language == 'zh_CN' || language == 'en_US') {
		// 	return 'THB'
		// }
		return 'THB'
	}
	if(sys=='EJSHOP'){
		return 'CNY'
	}
}

function formatPriceNumber(num, type) {
	var [upper, lower] = num.toString().split('.')
	var arr = []
	for (var i = 0; i < upper.length; i = i + 3) {
		arr.unshift(upper.substring(upper.length - i - 3, upper.length - i))
	}
	if (type == 1) {
		let res = arr.join(",")
		if (lower) res += '.' + lower
		return res
	}
	if (type == 2) {
		let res = arr.join(" ")
		if (lower) res += ',' + lower
		return res
	}
}

function mutilNum(type, num, hnum) {
	if(!parseFloat(num))return num
	if (hnum && num != hnum) {
		return formatPriceNumber(num, type) + ' - ' + formatPriceNumber(hnum, type)
	} else {
		return formatPriceNumber(num, type)
	}

}

export function formatPrice(num, hnum) {
	var cur = getCurrency()
	if ((!num && num !== 0)||num<0) return null
	switch (cur) {
		case "EUR": {
			return "€ " + mutilNum(1, num, hnum)
		}
		case "AUD": {
			return "AU $" + mutilNum(1, num, hnum)
		}
		case "GBP": {
			return "￡ " + mutilNum(1, num, hnum)
		}
		case "CAD": {
			return "C$ " + mutilNum(1, num, hnum)
		}
		case "CHF": {
			return "CHF " + mutilNum(1, num, hnum)
		}
		case "USD": {
			return "US $" + mutilNum(1, num, hnum)
		}
		case "RUB": {
			return mutilNum(2, num, hnum) + ' руб.'
		}
		case "PLN": {
			return mutilNum(2, num, hnum) + ' zł'
		}
		case "THB": {
			return '฿' + mutilNum(1, num, hnum)
		}
		// case "THB2": {
		// 	return mutilNum(1, num, hnum) + ' บาท'
		// }
		case 'MXN': {
			return mutilNum(1, num, hnum) + ' MXN$'
		}
		case 'BRL': {
			return 'R$ ' + mutilNum(2, num, hnum)
		}
		case 'CNY':{
			return '¥ '+mutilNum(1, num, hnum)
		}
        case 'JPY': {
            return '￥ '+mutilNum(1, num, hnum)
        }
        case 'KRW': {
            return '₩ '+mutilNum(1, num, hnum)
        }
	}
	return null
}